module.exports = __webpack_public_path__ + "img/75600.37690fe4.jpg";